import React, { Component } from "react";
import { PageHeader, ServicePageBody } from "../components";
import axios from "axios";
import {
  API_DETAIL_SERVICE_BYID,
  API_DETAIL_SERVICE,
  API_MAIN,
} from "../utils/api";
import bg_our_service from "../assets/images/pageHeader/img-services-header.jpg";

export class Detail_service extends Component {
  constructor(props) {
    super(props);

    this.state = {
      detail: [],
      detail2: [],
      slug: "",
      main: [],
    };
  }

  componentDidMount() {
    this.getMain();
  }

  componentDidUpdate(prevProps) {
    this.getMain();
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      this.getData(this.props.match.params.slug);
    }
  }

  getData(slug) {
    const headers = {};
    axios
      .get(API_DETAIL_SERVICE + "?slug=" + slug, { headers: headers })
      .then((res) => {
        const detail = res.data.services;
        this.setState({ detail });
        console.log(this.state.main.LANG);
        if (this.state.main.LANG) {
          if (detail.LANG != this.state.main.LANG) {
            if (detail.LANG_REF == 0) {
              window.location.href = "/home";
              // console.log("0");
            } else {
              axios
                .get(API_DETAIL_SERVICE_BYID + "?id=" + detail.LANG_REF, {
                  headers: headers,
                })
                .then((res) => {
                  const detail2 = res.data.services;
                  this.setState({ detail2 });
                  window.location.href = "/service/" + detail2.SLUG;
                });
            }
          } else {
            console.log("LANG sama");
          }
        } else {
          console.log("LANG UNDIFINED");
        }
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getMain() {
    const headers = {};
    axios
      .get(API_MAIN, { headers: headers })
      .then((res) => {
        const main = res.data.main;
        this.setState({ main });
        this.getData(this.props.match.params.slug);
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const { detail, main } = this.state;
    const param = {
      title: detail.TITLE,
      subtitle: detail.SUB_TITLE,
      breadcrumb: detail.TITLE,
      back: "service",
      bg_image: bg_our_service,
      home: main.home,
    };

    return (
      <main>
        <div role="main" className="main">
          <PageHeader param={param} />
          <ServicePageBody param={detail} title={param} main={main} />
        </div>
      </main>
    );
  }
}

export default Detail_service;
